import NoRecordsFound from "customComponents/NoRecordsFound";
import { JobAuthenStatusComponent } from "data/jobAuthenStatus";
import React from "react";

export default function JobHistories({ values = [] }) {
  if (values.length === 0) return <NoRecordsFound />;

  return (
    <div className="col-12">
      <div className="ibox-content inspinia-timeline">
        {values.map((item, itemIndex) => (
          <div className="timeline-item" key={itemIndex}>
            <div className="row">
              <div className="col-3 date">
                <i className="fa fa-file-text"></i>
                {item.createdAt}
                <br />
                {item.status && (
                  <JobAuthenStatusComponent value={item.status} />
                )}
              </div>
              <div className="col-9 content no-top-border">
                <p className="m-b-xs">
                  <strong>{item.name}</strong>
                </p>
                {item.message ?? ""}
                {item.assetsPreview && (
                  <ul className="list-unstyled">
                    {item.assetsPreview.map((asset) => (
                      <li>
                        <i className="fa fa-file mr-2"></i>
                        <a href={`${asset.url}`} target="_blank">
                          {asset.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
